<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import IconLocked from "#/assets/iconsDynamic/Locked.vue";
import { useModal } from "#/composables/useModal";
import { useMainStore } from "#/store/main";
import { useModalStore } from "#/store/modals";
import type { IProduct } from "#/types/iCardProduct";
import { getLocaleName } from "#/utils/i18next";

const emit = defineEmits<(e: "confirm") => void>();

const { t, i18next } = useTranslation();
const { visible, close } = useModal<IProduct>("cart-adult-reset");

const modals = useModalStore();
const storeMain = useMainStore();

const adultProducts = computed(() => storeMain.cartProducts_lib?.filter((product) => product.adult) || []);
const badges = computed(() => Array.from(new Set(adultProducts.value.map((product) => getLocaleName(product, i18next.language)))));

const onConfirm = () => {
	emit("confirm");
	close();
};

const onCancel = () => {
	close();
	modals.open("cart-adult-confirm");
};
</script>

<template>
	<Transition name="fade">
		<div v-if="visible" class="cart_adult_modal_overlay">
			<div class="cart_adult_modal_content">
				<div class="lockbig">
					<IconLocked />
				</div>
				<h2 class="mtitle">{{ t("modal.cart-adult-reset.title") }}</h2>
				<p class="msub">{{ t("modal.cart-adult-reset.description") }}</p>
				<div class="itemchips">
					<span class="ichip" v-for="product in badges" :key="product">{{ product }}</span>
				</div>
				<div class="mrow">
					<button type="button" class="btn-ghost" @click="onCancel">
						{{ t("modal.cart-adult-reset.button.cancel") }}
					</button>
					<button type="button" class="btn-danger" @click="onConfirm">
						{{ t("modal.cart-adult-reset.button.confirm") }}
					</button>
				</div>
			</div>
		</div>
	</Transition>
</template>

<style lang="scss" scoped>
  @use './cartAdultReset.scss';
</style>
